import React, { useEffect, useState, useContext } from "react";
import AppContext from '../../context/AppProvider';
import {useHistory} from 'react-router-dom'

import Container from '@mui/material/Container';

import JobDetails from "../../components/jobDetails";
import BasicModalInformation from "../../components/basicModalInformation";
import SignalREncorehiveContext from "../../context/signalREncorehive";

const Job = () => {
  let history= useHistory();

  const {setCurrentJob, currentJob } = useContext(AppContext);
  const { signalREncorehive: signalRConnection } = useContext(SignalREncorehiveContext);

  const [jobWasEscalated, setJobWasEscalated] = useState(false);
  
  const [width, setWidth] = useState(window.innerWidth);

  function handleScalation(scalationInfo){
    console.log("scalationInfo: " + JSON.stringify(scalationInfo));
  }

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    if (signalRConnection) {

      signalRConnection.on("HardEscalate", function (jobId) {
        console.log("signalR ,job hard escalate jobId: " + jobId);
        if(currentJob && currentJob.id == jobId)
        setJobWasEscalated(true);
      });
    }

  }, [signalRConnection]);

  return (
    <Container sx={{ marginTop: '7em', display:'flex', justifyContent:'center' }}>

      <JobDetails handleScalation={handleScalation}/>
      
      <BasicModalInformation
        title= {"An Admin is now the owner of this Job. Please navigate back to the Honeycomb and claim another Job."}
        open= {jobWasEscalated}
        handleClose={()=>{
          setCurrentJob(null);
          history.push("/dashboard/jobs")}
        }
      />
      

    </Container>
  );
};

export default Job;
